module.exports = __webpack_public_path__ + "img/bc646e1.jpg";